import * as React from 'react'

function IconDefaultLesson(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={65}
      height={65}
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.395 63.789c17.338 0 31.394-14.056 31.394-31.395C63.789 15.056 49.733 1 32.394 1 15.056 1 1 15.056 1 32.395c0 17.338 14.056 31.394 31.395 31.394z"
        fill="#fff"
      />
      <path
        d="M32.395 63.789c17.338 0 31.394-14.056 31.394-31.395C63.789 15.056 49.733 1 32.394 1 15.056 1 1 15.056 1 32.395c0 17.338 14.056 31.394 31.395 31.394z"
        stroke="#F4BA27"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M32.394 59.388c14.909 0 26.995-12.085 26.995-26.994C59.389 17.486 47.303 5.4 32.394 5.4 17.486 5.4 5.4 17.486 5.4 32.394c0 14.909 12.086 26.994 26.994 26.994z"
        stroke="#F4BA27"
        strokeWidth={0.75}
        strokeMiterlimit={10}
      />
      <path
        d="M23.54 24.268l1.729 3.072 4.224-2.4v13.728h-5.44v3.936h15.232v-3.936h-5.44v-19.04H31.7l-8.16 4.64z"
        fill="#000"
      />
    </svg>
  )
}

export default IconDefaultLesson
